import React, { useEffect, useRef} from 'react';
import { StyledHero3dCommerce } from './StyledHero3dCommerce';
import {
  setLoader,
} from "../../redux/loader/loader.actions";
import { useDispatch } from "react-redux";
import { useHistory } from 'react-router-dom';
import { gsap } from "gsap";
import HeroConfig from '../HeroConfig';

const Hero3dCommerce = ({ title, img }) => {
  const titleRef = useRef(null);
  const dispatch = useDispatch();
  let history = useHistory();
  const clickLink = () => {
    dispatch(setLoader(true));
    setTimeout(() =>{ 
      document.body.scrollTop = 0;
      history.push('/3d-commerce-experience')
    }, 500);
  }
  useEffect(() => {
    const sliderSubs = document.querySelectorAll('.subtitle-slider p');
    let index = 0;
    let prevIndex = null;
    const animation = () => {
      if (prevIndex === null) {
        
        gsap.to(sliderSubs[index], {
          opacity: 1, duration: 0.5, ease: 'power2.easeOut',
          onComplete: () => {
            prevIndex = index;
            index = (index + 1) >= sliderSubs.length ? 0 : (index + 1);
            gsap.delayedCall(2.5, animation)
          }})

      } else {
        gsap.to(sliderSubs[prevIndex], {
          opacity: 0, duration: 0.5, delay: 2.5, ease: 'power2.easeOut',
          onComplete: () => {
            gsap.to(sliderSubs[index], {
              opacity: 1, duration: 0.5, ease: 'power2.easeOut',
              onComplete: () => {
                prevIndex = index;
                index = (index + 1) >= sliderSubs.length ? 0 : (index + 1);
                animation()
              }
            })
          }
        })
      }
      
      
    }
    animation();

    return () => {
      gsap.killTweensOf('.subtitle-slider p')
    }
  },[])
  return (
    <React.Fragment>
      {
          <StyledHero3dCommerce>
            <div className="title--wrap">
              <h4 ref={titleRef} className="big--title" dangerouslySetInnerHTML={{ __html: title }}></h4> 
              <div className='subtitle-slider'>
                <p className='preset-10'>Experience the difference with our 3D digital twins</p>
                <p className='preset-10'>Boost your e-commerce conversions up to 40%</p>
              </div>
              <div className="rounded--cta" onClick={clickLink}>
                <p className="preset-12">Try our solution</p>
              </div>
            </div>
          <HeroConfig />
        </StyledHero3dCommerce>          
      }

      <div className="center--paragraph">
        <h6 className="big--title">
          Improve your ecommerce customer experience.
Innovate your static website, engage your page visitors and increase your conversions by implementing 3D digital twins. Get ahead of your
competition!
        </h6>
        
      </div>
      
    </React.Fragment>
  );
};

export default Hero3dCommerce;
